import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2417bd40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-index" }
const _hoisted_2 = { class: "product-list" }
const _hoisted_3 = { class: "product" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ShopTabs = _resolveComponent("ShopTabs")!
  const _component_goods_list = _resolveComponent("goods-list")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { skipPath: $setup.skipPath }, {
      center: _withCtx(() => [
        _createVNode(_component_van_search, {
          modelValue: $setup.searchKeyword,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchKeyword) = $event)),
          shape: "round",
          "show-action": "",
          "left-icon": "",
          placeholder: "I'm looking for...",
          onFocus: $setup.onSearchValue,
          ref: "refsFocus"
        }, {
          action: _withCtx(() => [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onSearchValue($setup.searchKeyword)))
            }, "search")
          ]),
          _: 1
        }, 8, ["modelValue", "onFocus"])
      ]),
      _: 1
    }, 8, ["skipPath"]),
    _createVNode(_component_ShopTabs, { onScreeningClick: $setup.screeningClick }, null, 8, ["onScreeningClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_list, {
        loading: $setup.loading,
        "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => (($setup.loading) = $event)),
        finished: $setup.finished,
        "finished-text": "No more",
        "loading-text": "loading",
        onLoad: $setup.onLoad
      }, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.banner.product_rank, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.goods_id
              }, [
                _createVNode(_component_goods_list, { data: item }, null, 8, ["data"])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["loading", "finished", "onLoad"])
    ])
  ]))
}